import { EMPTY, of } from 'rxjs'
import { switchMap } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import * as Actions from 'store/actions/index.ts'
import { getIsProdEnv, getIsPreviewMode } from 'store/selectors'

const disableOnPreviewProductionEpic = (
  actions$,
  state$
) => actions$.pipe(
  ofType(Actions.member.MEMBER_INFO_FETCHED),
  switchMap(() => {
    const state = state$.value

    return (getIsProdEnv(state) && getIsPreviewMode(state))
      ? of(Actions.tracking.onDisableMixPanelTracking())
      : EMPTY
  })
)

export default disableOnPreviewProductionEpic
